export default __webpack_public_path__ + "static/media/Deals.4664c91e.webp";